export default {
  menus: {
    topNavMenu: [
      {name: "tasks", label: "_tasks" }, 
      {name: "browse", label: "_browse" },
      {name: "search", label: "_search" },
      {name: "preview", label: "_preview" },
      {name: "edit", label: "_editor" },
      {name: "logout", label: "_logout" }
    ],
    taskContextMenu: [
      {name: "details", label: "_viewdetails" },
      {name: "claim", label: "_claimtask" },
      {name: "unclaim", label: "_unclaimtask" },
      {name: "finish", label: "_finishtask" },
    ],
    taskHistoryItemContextNenu: [
      {name: "details", label: "_viewdetails" }
    ],
    fileMenu: {
      propertiesItem: {name: "properties", label: "_properties" } ,
      previewMenuItem:  {name: "preview", label: "_preview"} ,  
      editMenuItem:  {name: "edit", label: "_edit"} ,  
      editHeadMenuItem:  {name: "edit", label: "_edit_head"} ,  
      removeMenuItem:  {name: "remove", label: "_remove"} ,  
      editDitabaseMenuItem:  {name: "editditabase", label: "_editditabase" } , 
      highlightFileFolder:  {name: "highlightfolder", label: "_highlightfolder" }, 
      openfilelocationMenuItem:  {name: "openfilelocation", label: "_openfilelocation" }, 
      deleteMenuItem:  {name: "delete", label: "_delete" }, 
      previewNewWindow: {name: "previewnewwindow", label: "_previewnewwindow" } ,
      toggleDoneMenuItem: {name: "toggledone", label: "_toggledone" }
      
      },
    folderMenu: [
        {name: "import", label: "_importfile" } ,
        {name: "newfromtemplate", label: "_create"}
        ],
    langs: [
      {name: 'en-Us', id: "1"},
      {name: 'fr-FR', id:"2"}
    ],
    mimetypes: [
      {name: 'All',value: "all"},
      {name: 'text/xml',value: "text/xml"},
      {name: 'text/html',value: 'text/html'}
    ],
    editor_modes: [
      {name: 'readonly',value: "_readonly"},
      {name: 'review',value: "_review"},
      {name: 'author',value: "_author"}
    ],
    editor_moremenu: [
        
        {name: 'open',value: "_open", icon: "vaadin:folder-open",  available_in_readonly_mode: true },
        {name: 'close',value: "_close", icon: "vaadin:close",  available_in_readonly_mode: true },
        {name: 'print',value: "_print", icon: "vaadin:print",  available_in_readonly_mode: true },
        {name: 'tags',value: "_tags", icon: "vaadin:code",  available_in_readonly_mode: true },
        {name: 'validate',value: "_validate", icon:"vaadin:check-circle-o",  available_in_readonly_mode: false },
        {name: 'comments',value: "_comments", icon: "vaadin:comments",  available_in_readonly_mode: false },
        {name: 'find',value: "_find", icon:"vaadin:search",  available_in_readonly_mode: false },
        {name: 'undo',value: "_undo", icon: "vaadin:reply",  available_in_readonly_mode: false },
        {name: 'redo',value: "_redo", icon: "vaadin:share",  available_in_readonly_mode: false }
    ],
    editor_tabs: [
      {name: 'ditamaps' , label: '_ditamaps', active: false},
      {name: 'tasks' , label: '_tasks', active: false},
      {name: 'fileinfo' , label: '_fileinfo', active: false},
      {name: 'mru' , label: '_mru', active: false}
  ]

  },
  search_filters: [
    {name: 'folder' , label: '_folder', active: false},
  ],
 
  
};


